<template>
  <div class="settings">
    <div class="container view">
      <HeaderComponent :title="$metaInfo.title" />

      <StepperComponent :value="steps" ref="stepper" state-handler="route" submit="submit" />
    </div>
  </div>
</template>

<script>
import HeaderComponent from '@/components/Header'
import { StepperComponent } from 'vue-elder-stepper'
import Steps from './Steps'

export default {
  props: {
    step: String,
  },
  computed: {
    steps() {
      let props = {}
      let listeners = {}

      return Steps().map(raw => {
        const { icon, ...s } = raw
        s.props = {
          ...(s.props || {}),
          ...props,
        }
        s.listeners = {
          ...(s.listeners || {}),
          ...listeners,
        }
        return s
      })
    },
  },
  metaInfo() {
    return {
      title: this.$t('settings'),
    }
  },
  components: {
    HeaderComponent,
    StepperComponent,
  },
}
</script>

<style lang="scss">
.settings {
  background-color: $background-grey;

  .elder-stepper__component > * {
    margin: 2rem auto;
  }
}
</style>
